import { render, staticRenderFns } from "./BoardEntryRow.vue?vue&type=template&id=093004be&scoped=true"
import script from "./BoardEntryRow.vue?vue&type=script&lang=ts"
export * from "./BoardEntryRow.vue?vue&type=script&lang=ts"
import style0 from "./BoardEntryRow.vue?vue&type=style&index=0&id=093004be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093004be",
  null
  
)

export default component.exports